export default "__VITE_ASSET__DjAArV70__"